<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<h1 class="P_Heading_1__And__Page_Break"><span><img alt="" src="image4.jpg" style=" max-width: 100%; max-height: 100%;"/></span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal">This one is dedicated to all of those people who chose family first and dreams second, because they know that making a dream come true isn’t nearly as much fun without someone to share it with.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?0fdff45f